const BookingPageUrl = "/";

export const RouteNames = {
  SelectTicket: "SelectTicket",
  MyBookings: "MyBookings",
  MySettings: "MySettings",
  Login: "Login",
  Register: "Register",
  BoatDetails: "BoatDetails",
  ManageBoats: "ManageBoats",
  ContactInformation: "ContactInformation",
  ChooseSeason: "ChooseSeason",
  DatePicker: "DatePicker",
  ReturnDatePicker: "ReturnDatePicker",
  Equipment: "Equipment",
  Addons: "Addons",
  BookingOverview: "BookingOverview",
  Payment: "Payment",
  BookingConfirmation: "BookingConfirmation",
  SluiceHost: "SluiceHost",
  IneligibleView: "IneligibleView",
} as const;

export type RouteName = typeof RouteNames[keyof typeof RouteNames];
export type RoutePath = `/${string}`;
export type RouteTarget = RouteName | RoutePath;

const routePaths = {
  [RouteNames.SelectTicket]: "/",
  [RouteNames.MyBookings]: "/my-bookings",
  [RouteNames.MySettings]: "/my-settings",
  [RouteNames.Login]: "/login",
  [RouteNames.Register]: "/register",
  [RouteNames.BoatDetails]: "/boatdetails",
  [RouteNames.ManageBoats]: "/manage-boats",
  [RouteNames.ContactInformation]: "/contact",
  [RouteNames.ChooseSeason]: "/chooseseason",
  [RouteNames.DatePicker]: "/datepicker",
  [RouteNames.ReturnDatePicker]: "/return-datepicker",
  [RouteNames.Equipment]: "/equipment",
  [RouteNames.Addons]: "/addons",
  [RouteNames.BookingOverview]: "/booking-overview",
  [RouteNames.Payment]: "/payment",
  [RouteNames.BookingConfirmation]: "/booking-confirmation",
  [RouteNames.SluiceHost]: "/slussvard",
  [RouteNames.IneligibleView]: "/forbidden",
} as const satisfies Record<RouteName, string>;

export function isRouteName(routeName: unknown): routeName is RouteName {
  return typeof routeName === "string" && Object.values(RouteNames).includes(routeName as RouteName);
}

export function isRoutePath(routeTarget: RouteTarget): routeTarget is RoutePath {
  return routeTarget.startsWith("/");
}

// So we don't have to use the vue router on CMS pages (that use the site header)
export function getBookingRouteUrl(routeName: RouteName): string {
  return `${BookingPageUrl}#${routePaths[routeName] ?? routePaths[RouteNames.SelectTicket]}`;
}
